import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M8 0.5C6.01088 0.5 4.10322 1.29018 2.6967 2.6967C1.29018 4.10322 0.5 6.01088 0.5 8C0.5 8.98491 0.693993 9.96018 1.0709 10.8701C1.44781 11.7801 2.00026 12.6069 2.6967 13.3033C3.39314 13.9997 4.21993 14.5522 5.12987 14.9291C6.03982 15.306 7.01509 15.5 8 15.5C8.98491 15.5 9.96018 15.306 10.8701 14.9291C11.7801 14.5522 12.6069 13.9997 13.3033 13.3033C13.9997 12.6069 14.5522 11.7801 14.9291 10.8701C15.306 9.96018 15.5 8.98491 15.5 8C15.5 6.01088 14.7098 4.10322 13.3033 2.6967C11.8968 1.29018 9.98912 0.5 8 0.5ZM10.7803 7.03033C11.0732 6.73744 11.0732 6.26256 10.7803 5.96967C10.4874 5.67678 10.0126 5.67678 9.71967 5.96967L7.25 8.43934L6.28033 7.46967C5.98744 7.17678 5.51256 7.17678 5.21967 7.46967C4.92678 7.76256 4.92678 8.23744 5.21967 8.53033L6.71967 10.0303C7.01256 10.3232 7.48744 10.3232 7.78033 10.0303L10.7803 7.03033Z",
  fill: "white"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2
  ]))
}